var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuKeyTermDiscovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.085,
    height: 18.781,
    viewBox: "0 0 14.085 18.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark-text",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13210",
    "data-name": "Path 13210",
    d: "M5.587,7a.587.587,0,0,0,0,1.174h5.869a.587.587,0,1,0,0-1.174ZM5,9.934a.587.587,0,0,1,.587-.587h5.869a.587.587,0,1,1,0,1.174H5.587A.587.587,0,0,1,5,9.934m0,2.348a.587.587,0,0,1,.587-.587H7.934a.587.587,0,0,1,0,1.174H5.587A.587.587,0,0,1,5,12.282",
    transform: "translate(0.521 1.217)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13211",
    "data-name": "Path 13211",
    d: "M10.8,0H4.348A2.348,2.348,0,0,0,2,2.348V16.433a2.348,2.348,0,0,0,2.348,2.348h9.39a2.348,2.348,0,0,0,2.348-2.348V5.282Zm0,1.174V3.521a1.761,1.761,0,0,0,1.761,1.761h2.348V16.433a1.174,1.174,0,0,1-1.174,1.174H4.348a1.174,1.174,0,0,1-1.174-1.174V2.348A1.174,1.174,0,0,1,4.348,1.174Z",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuKeyTermDiscovery);
export default __webpack_public_path__ + "static/media/Mainmenu-key-term-discovery.6269b72ad82bbb43d50a7b1fc3f696c8.svg";
export { ForwardRef as ReactComponent };